<template>
  <div>
    <div
      v-if="!$apollo.queries.getNotifications.loading || allNotifications.length"
      class="notifications-list"
    >
      <Layout class="notification-list__empty" v-if="allNotifications.length === 0">
        <Column size="1" />
        <Column size="10">
          <ActionCard
            :image="require('../assets/emptyNotifications.svg')"
            text="No hay notificaciones nuevas"
          />
        </Column>
      </Layout>

      <Layout v-if="allNotifications.length !== 0">
        <Column size="6">
          <span @click="page = 1" class="notifications-actions notifications-actions__clickable"
            >Más recientes</span
          >
        </Column>
        <Column size="6" align="right">
          <!-- <span class="notifications-actions" @click="markAllAsRead"
            >Marcar como leídas</span
          > -->
        </Column>
      </Layout>
      <div v-for="item in allNotifications" :key="item.ID" class="notification-list__item">
        <div class="notification-list__close" @click="() => markAsRead(item)">
          <i class="mdi mdi-close"></i>
        </div>
        <div class="notification-list__image">
          <span class="notification-list__circle"> P </span>
        </div>
        <div class="notification-list__information">
          <div class="notification-list__item-text">
            <span>
              {{ item.Message }}
            </span>
          </div>
          <div class="notification-list__item-detail">
            <Layout>
              <Column size="6">
                <span>Timbrado</span>
              </Column>
              <Column size="6">
                <span>
                  {{ item.CreatedAt | moment('from', 'now') }}
                </span>
              </Column>
            </Layout>
          </div>
        </div>
      </div>
      <Layout v-if="allNotifications.length !== 0">
        <Column size="6">
          <span
            v-if="page > 1"
            @click="loadOneLessPage"
            class="notifications-actions notifications-actions__clickable"
            >Anterior</span
          >
        </Column>
        <Column size="6" align="right">
          <span
            v-if="page < pages"
            @click="loadOneMorePage"
            class="notifications-actions notifications-actions__clickable"
            >Siguiente</span
          >
        </Column>
      </Layout>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';
import Layout from './Layout.vue';
import Column from './Column.vue';

export default {
  name: 'NotificationsList',
  props: {
    showNotifications: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Layout,
    Column,
  },
  apollo: {
    getNotifications: {
      pollInterval: 60000,
      query: gql(`query GetNotifications($UserID: String!, $OrgCode: String!, $Page: Int ) {
        getNotifications(UserID: $UserID, OrgCode: $OrgCode, Page: $Page) {
          items {
            ID
            UserID
            OrgCode
            Title
            Message
            Readed
            CreatedAt
          }
          Pages
          totalItems
        }
      }`),
      variables() {
        return {
          UserID: this.user.profile.UserName,
          OrgCode: this.organization.organizationCode,
          Page: this.page || 1,
        };
      },
      subscribeToMore: {
        document: gql(`subscription OnCreateNotification($UserID: String!,$OrgCode: String!){
          onCreateNotification(UserID: $UserID, OrgCode: $OrgCode) {
            ID,
            Title,
            Message,
            UserID,
            Readed,
            CreatedAt,
            OrgCode
          }
        }`),
        variables() {
          return {
            UserID: this.user.profile.UserName,
            OrgCode: this.organization.organizationCode,
          };
        },
        updateQuery(previousResult, { subscriptionData }) {
          previousResult.getNotifications.items.push(subscriptionData.data.onCreateNotification);
          if (document.visibilityState === 'hidden') {
            if (Notification.permission === 'granted') {
              new Notification(subscriptionData.data.onCreateNotification.Title, {
                icon: `${window.location.origin}/favicon.ico`,
                body: subscriptionData.data.onCreateNotification.Message,
                timestamp: subscriptionData.data.onCreateNotification.CreatedAt,
                tag: subscriptionData.data.onCreateNotification.Message.ID,
              });
            }
          } else {
            this.$root.$emit('notificationPanelAdd', subscriptionData.data.onCreateNotification);
          }
        },
      },
    },
  },
  data() {
    return {
      notification: null,
      notifications: [],
      page: 1,
      pages: 0,
      notificationConfiguration: {
        icon: `${window.location.origin}/favicon.ico`,
      },
    };
  },
  mounted() {
    if ('Notification' in window) {
      if (Notification.permission !== 'granted') {
        Notification.requestPermission((permission) => {
          if (permission === 'granted') {
            new Notification(
              'Gracias por activar las notificaciones.',
              this.notificationConfiguration
            );
          }
        });
      }
    }
  },
  methods: {
    loadOneMorePage() {
      this.page += 1;
    },
    loadOneLessPage() {
      this.page -= 1;
    },
    markAllAsRead() {
      const query = gql(`mutation UpdateAllNotification($UserID: String!, $OrgCode: String!){
          updateAllNotification(UserID: $UserID, OrgCode: $OrgCode) {
            Pages
            totalItems
            items {
              ID
              UserID
              OrgCode
              Title
              Message
              Readed
              CreatedAt
            }
          }
      }`);
      this.$apollo
        .mutate({
          mutation: query,
          variables: {
            UserID: this.user.profile.UserName,
            OrgCode: this.organization.organizationCode,
          },
        })
        .then(() => {
          // console.log(data);
        });
    },
    markAsRead(item) {
      const query =
        gql(`mutation UpdateNotification($ID: String!,$UserID: String!, $OrgCode: String!){
        updateNotification(ID: $ID, UserID: $UserID, OrgCode: $OrgCode) {
          ID
          UserID
          Title,
          Readed
        }
      }`);
      this.$apollo
        .mutate({
          mutation: query,
          variables: {
            ID: item.ID,
            UserID: item.UserID,
            OrgCode: item.OrgCode,
          },
        })
        .then(({ data }) => {
          if (data.updateNotification) {
            item.Readed = true;
            this.$emit('countNotifications', this.allNotifications.length);
          }
        });
    },
  },
  computed: {
    ...mapState('User', ['user']),
    allNotifications() {
      return [...((this.getNotifications || {}).items || []).filter((x) => !x.Readed)];
    },
  },
  watch: {
    'getNotifications.items': {
      deep: true,
      handler() {
        this.$emit('countNotifications', this.allNotifications.length);
      },
    },
    'getNotifications.Pages'(val) {
      this.pages = val;
    },
    showNotifications(val) {
      if (val !== true && this.page !== 1) {
        this.page = 1;
      }
    },
  },
};
</script>

<style lang="scss">
.notification-list__circle {
  width: 40px;
  height: 40px;
  display: flex;
  background-color: #6ae1c8;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.notification-list {
  &__empty {
    margin-top: 120px;
  }
  &__image {
    margin-right: 8px;
  }
  &__information {
    flex: auto;
    padding-right: 20px;
  }
}
.notification-list__item {
  display: flex;
  background-color: #f2f5f8;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  &:hover {
    background-color: #ecf1fb;
    .notification-list__close {
      display: block;
    }
  }
  &-text {
    color: #333333;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 4px;
  }
  &-detail {
    font-size: 12px;
    line-height: 16px;
    color: #9ba2a8;
  }
}

.notifications-actions {
  color: #9ba2a8;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
  &__clickable {
    cursor: pointer;
  }
}
.notification-list__close {
  position: absolute;
  right: 12px;
  top: 12px;
  color: #9ba2a8;
  cursor: pointer;
  display: none;
}
</style>
